<template>
  <div class="ReportArea">
    <div class="row">
      <div class="col-md-6">
        <div v-if="isNielsenCompany" class="PagePanelDashboard">
          <div class="customeHeaderTitle mt-1">Installation Progression</div>
          <div class="install">
            <div class="GraphDiv" v-if="installDetails.length > 0">
              <InstallationProgChart
                :installDetails="installDetails"
                :chartCenterText="chartCenterText"
              />
            </div>
            <div class="GraphDetails" v-if="installDetails.length > 0">
              <div
                v-for="(IRow, index) in installDetails"
                :key="index"
                class="ChartItem"
                :class="{ ItemDivider: index != 0 }"
              >
                <span :style="{ color: IRow.color, paddingRight: '8px' }">
                  <font-awesome-icon icon="circle" />
                </span>
                <span>{{ IRow.text }}</span>
                <span style="float: right">{{ IRow.val }} Channels</span>
              </div>
            </div>
          </div>
        </div>
        <div class="PagePanelDashboard" v-if="livecount > 0">
          <div class="customeHeaderTitle">Channel Status</div>
          <div class="BarGraphDiv">
            <NonCCRChannelStatusChart
              :dmaID="dmaID"
              :dmaNameAndRank="dmaNameAndRank"
              :dmaNameForFilter="dmaNameForFilter"
              @status-data-loaded="isStatusDataLoaded"
            />
          </div>
        </div>
        <div class="PagePanelDashboard" v-if="livecount > 0">
          <div class="customeHeaderTitle">Channel Uptime</div>
          <div style="display: flex; width: 100%" v-show="checkUptimeHasData">
            <div class="BarGraphDivUptime">
              <ChannelUptimeChart
                :ref="monthlyUptimeRef"
                :dmaID="dmaID"
                :chartType="monthToDate"
                @chart-data="monthlyChartData"
              />
            </div>
            <div class="BarGraphDivUptime">
              <ChannelUptimeChart
                :ref="quaterlyUptimeRef"
                :dmaID="dmaID"
                :chartType="quarterToDate"
                @chart-data="quarterlyChartData"
              />
            </div>
          </div>
          <div class="NoDataHeader text-center" v-if="!checkUptimeHasData">
            <span>No Live Channels to Display</span><br /><span>
              See Channels List Page for More Information
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <!-- Open activities -->
        <div class="PagePanelDashboard">
          <div class="row px-2">
            <div class="customeHeaderTitle col-md-6">Open Activities</div>
            <div class="col-md-6 ml-auto">
              <div class="right">
                <DxButton
                  class="
                    dx-btn-text-transform-none
                    btn-box-shadow
                    dx-btn-font-normal
                    create-service
                  "
                  text="Create New Service Event"
                  styling-mode="contained"
                  @click="showOpenEventModal = true"
                />
              </div>
            </div>
          </div>
          <div v-if="openEvents != '' && scheduleEvents != ''">
            <div class="row pt-2 ml-2">
              <div class="col-md-6">
                <span class="pointer" @click="onEventPageClicked(7)">
                  <span style="background-color: #f78f2a" class="circle">
                    <icon-base
                      icon-name="IconAlertTriangle"
                      :height="28"
                      :width="28"
                      style="padding-top: 6px"
                    >
                      <icon-AlertTriangle />
                    </icon-base>
                  </span>
                  <span style="padding-left: 9px">{{ this.openEvents }}</span>
                </span>
              </div>
              <div class="col-md-6" v-if="isNielsenCompany">
                <span @click="toChannelVerification('All')" class="pointer">
                  <span
                    style="background-color: #006ca5"
                    class="visible-circle"
                  >
                    <icon-base
                      class="icon-middle"
                      icon-name="IconVisible"
                      :height="28"
                      :width="28"
                      style="padding-top: 5px; margin-top: 6px"
                    >
                      <icon-Visible />
                    </icon-base>
                  </span>
                  <span style="padding-left: 9px">
                    {{ this.numberOfChannelVerification }} Channel Verifications
                    Required
                  </span>
                </span>
              </div>
            </div>
            <div class="row ml-2">
              <div class="col-md-6">
                <span class="pointer" @click="onEventPageClicked(8)">
                  <span style="background-color: #6fa234" class="circle">
                    <icon-base
                      icon-name="IconSoftware"
                      :height="28"
                      :width="28"
                      style="padding-top: 5px; margin-top: 3px"
                    >
                      <icon-Software />
                    </icon-base>
                  </span>
                  <span style="padding-left: 9px">{{
                    this.scheduleEvents
                  }}</span>
                </span>
              </div>
              <div v-if="isNielsenCompany" class="col-md-6">
                <span class="pointer" @click="toChannelVerification('Reject')">
                  <span style="background-color: #d24b4b" class="failed-circle">
                    <icon-base
                      class="icon-middle"
                      icon-name="IconFailed"
                      :height="28"
                      :width="28"
                      style="padding-top: 4px; margin-top: 5px"
                    >
                      <icon-Failed />
                    </icon-base>
                  </span>
                  <span style="padding-left: 9px">
                    {{ numberOfChannelRejected }} Channels Rejected
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="NoDataHeader text-center"
            v-else-if="
              (openEvents == '' || scheduleEvents == '') && !showLoaderPanel
            "
          >
            <span> No Open Activities to Display </span>
          </div>
        </div>
        <div class="PagePanelDashboard">
          <div class="customeHeaderTitle">Location Information</div>
          <MapRadar v-if="mapData" :mapData="mapData" />
          <div class="row" style="padding-left: 13px" v-if="mapData">
            <div class="col-md-6">
              <span style="padding-right: 9px">
                <img
                  src="../../../../src/assets/img/Home.svg"
                  class="iconImg"
                />
              </span>
              <span>
                {{ numberWithCommas(mapData.Household_Pop) }} Households
              </span>
            </div>
            <div class="col-md-6">
              <span style="padding-right: 9px; cursor: pointer">
                <img
                  src="../../../../src/assets/img/US_Map.svg"
                  class="iconImg"
                />
              </span>
              <span>{{ mapData.Percent_US }}% of US population</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <customModal
        :show.sync="showOpenEventModal"
        :centered="true"
        :backdrop="true"
        :closeOnBackdrop="false"
        width="560px"
        :CCRColoBrand="true"
        :hideHeaderBar="true"
      >
        <CreateEvent
          v-if="showOpenEventModal"
          :dmaID="dmaID"
          @hide-modal="showOpenEventModal = false"
        />
      </customModal>
    </div>
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="showLoaderPanel"
      :show-indicator="true"
    />
  </div>
</template>
<script>
import { EventBus } from "../../../components/Events";
import DashboardMap from "../dashboardCharts/DashboardMap.vue";
import CreateEvent from "../../home/openEvent/CreateEvent.vue";
import { DxButton } from "devextreme-vue/button";
import MapRadar from "../dashboardCharts/MapRadar.vue";
import InstallationProgChart from "../dashboardCharts/InstallationProgChart.vue";
import NonCCRChannelStatusChart from "../dashboardCharts/channelStatus/NonCCRChannelStatusChart.vue";
import ChannelUptimeChart from "../dashboardCharts/ChannelUptimeChart.vue";
import IconAlertTriangle from "@/components/icons/IconAlertTriangle.vue";
import IconFailed from "@/components/icons/Attributes/IconFailed.vue";
import IconVisible from "@/components/icons/IconVisible.vue";
import IconSoftware from "@/components/icons/Features/IconSoftware.vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";

export default {
  name: "NonCCRDashBoardSection",
  components: {
    DashboardMap,
    MapRadar,
    InstallationProgChart,
    NonCCRChannelStatusChart,
    ChannelUptimeChart,
    IconAlertTriangle,
    IconFailed,
    IconVisible,
    IconSoftware,
    CreateEvent,
    DxButton,
    DxLoadPanel,
  },
  data() {
    return {
      installDetails: [],
      installationChartData: [],
      user: this.$auth.user.UserDetails,
      chartCenterText: "0/0",
      numberOfChannelVerification: 0,
      monthToDate: "Month-to-Date",
      quarterToDate: "Quarter-to-Date",
      livecount: 0,
      numberOfChannelRejected: 0,
      openEvents: "",
      scheduleEvents: "",
      showOpenEventModal: false,
      quarterlyChartLength: 0,
      monthlyChartLength: 0,
      monthlyUptimeRef: "monthlyUptimeRef",
      quaterlyUptimeRef: "quaterlyUptimeRef",
      channelStatusDataLoading: false,
      loaderVisible: false,
      loaderPosition: { of: ".ReportArea" },
      isMounted: false,
    };
  },
  props: {
    dmaID: Number,
    dmaNameForFilter: String,
    dmaNameAndRank: String,
    mapData: Object,
  },
  computed: {
    showLoaderPanel() {
      return (
        this.monthToDateLoader ||
        this.quarterToDateLoader ||
        this.loaderVisible ||
        (this.livecount > 0 ? !this.channelStatusDataLoading : false)
      );
    },
    isNielsenCompany() {
      return this.user.Company_RecID == 20822;
    },
    monthToDateLoader() {
      if (this.isMounted)
        return this.$refs.monthlyUptimeRef?.loaderVisible ?? false;
      return true;
    },
    quarterToDateLoader() {
      if (this.isMounted)
        return this.$refs.quaterlyUptimeRef?.loaderVisible ?? false;
      return true;
    },
    quarterToDateRef() {
      if (this.isMounted && this.quarterlyChartLength > 0)
        return this.$refs.quaterlyUptimeRef;
      return {};
    },
    monthToDateRef() {
      if (this.isMounted && this.monthlyChartLength > 0)
        return this.$refs.monthlyUptimeRef;
      return {};
    },
    checkUptimeHasData() {
      let monthToDateChart = this.monthToDateRef?.chartData;
      let quarterToDateChart = this.quarterToDateRef?.chartData;
      return monthToDateChart?.length > 0 && quarterToDateChart?.length > 0;
    },
  },
  mounted: function () {
    this.isMounted = true;
    this.getPieChartData();
    if (this.isNielsenCompany) {
      this.getChannelVerificationCount();
    }
    this.getOpenEvents();
  },
  watch: {},
  methods: {
    isStatusDataLoaded(data) {
      this.channelStatusDataLoading = data;
    },
    monthlyChartData(data) {
      this.monthlyChartLength = data.length;
    },
    quarterlyChartData(data) {
      this.quarterlyChartLength = data.length;
    },
    onEventPageClicked(type) {
      if (this.$route.name == "Event Details To Dashboard") {
        this.$router.push({
          name: "Events",
          params: {
            id: this.dmaID,
            type: type,
            dmaName: this.dmaNameAndRank.split(" (")[0],
          },
        });
      } else if (
        this.$route.name == "Events To Dashboard" ||
        this.$route.name == "Events To Dashboard via Event Details"
      ) {
        this.$router.push({
          name: "Events",
          params: {
            id: this.dmaID,
            type: type,
            dmaName: this.dmaNameAndRank.split(" (")[0],
          },
        });
      } else if (
        this.$route.name == "Home Channels to Market Dashboard" ||
        this.$route.path.includes("/channels/")
      ) {
        this.$router.push({
          name: "Channels Dashboard to Events",
          params: {
            type: type,
            MarketName: this.dmaNameAndRank.split(" (")[0],
          },
        });
      } else if (this.$route.path.includes("/market-")) {
        this.$router.push({
          name: "Market Dashboard to Events",
          params: {
            type: type,
            MarketName: this.dmaNameAndRank.split(" (")[0],
          },
        });
      } else {
        this.$router.push({
          name: "Home To Events",
          params: {
            id: this.dmaID,
            type: type,
            dmaName: this.dmaNameAndRank.split(" (")[0],
          },
        });
      }
    },
    numberWithCommas(x) {
      return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toChannelVerification(filterType) {
      setTimeout(() => {
        EventBus.$emit("filter-type-change", filterType);
      }, 100);
      this.$router.push({
        name: "Dashboard Channel Verification",
        params: {
          id: this.dmaID,
          filterDetails: [filterType, this.mapData.DMA_Name],
        },
      });
    },
    getChannelVerificationCount() {
      let th = this;
      let fltr = `?$filter=(DMA_RecID eq ${this.dmaID})&$count=true`;
      let url = `https://api.ccr.net/ColoM360/ClientVerificationChannel_View${fltr}`;
      this.$axios.get(url).then((response) => {
        th.numberOfChannelVerification = response.data.value.filter(
          (ClientVerification) => ClientVerification.ClientVerification
        ).length;
        th.numberOfChannelRejected = response.data.value.filter(
          (ChannelReject) => ChannelReject.ChannelRejected == true
        ).length;
      });
    },
    getPieChartData() {
      let th = this;
      let fltr = `?$filter=(DMA_RecID eq ${this.dmaID})&$orderby= PhaseOrder`;
      let url = `https://api.ccr.net/ColoM360/DMA_Dashboard_Phase_View${fltr}`;
      this.$axios.get(url).then((response) => {
        th.installationChartData = response.data.value;
        th.installationChartData.forEach((element) => {
          let obj = {
            color: `${element.PhaseColor}`,
            text: `${element.PhaseName}`,
            val: `${element.PhaseChannelCount}`,
          };
          th.installDetails.push(obj);
          if (element.PhaseName == "Live") {
            th.livecount = element.PhaseChannelCount;
            th.chartCenterText =
              element.PhaseChannelCount + "/" + element.DMAChannelCount;
          }
        });
      });
    },
    getOpenEvents() {
      this.loaderVisible = true;
      let companyId = this.$auth.user.UserDetails.Company_RecID;
      let url = `https://api.ccr.net/ColoM360/usp_GetOpenActivities`;
      let obj = {
        Company_RecID: [companyId],
        DMA_RecID: [this.dmaID],
      };
      this.openEvents = "";
      this.scheduleEvents = "";
      this.$axios.post(url, obj).then((response) => {
        const responseData = response.data;
        if (responseData.length > 0) {
          let open = responseData.filter((data) => data.OpenActivityID == 37);
          if (open.length > 0) {
            this.openEvents = open[0].Count + " " + open[0].Description;
          }
          let schedule = responseData.filter(
            (data) => data.OpenActivityID == 38
          );
          if (schedule.length > 0) {
            this.scheduleEvents =
              schedule[0].Count + " " + schedule[0].Description;
          }
        }
        this.loaderVisible = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.ReportArea::v-deep {
  background-color: #f1f1f1;
  color: black;
  margin: -4px 8px;
}
.modals::v-deep {
  .customModal .modal-content .modal-header {
    display: none;
  }
}
.PagePanelDashboard {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin: 0;
  border: 1px solid lightgray;
  padding: 15px;
  background-color: white;
  margin-bottom: 8px;
  min-height: 195px;
}
.GraphDetails {
  display: inline-block;
  width: 280px;
  text-align: left;
  margin-top: 5px;
  margin-left: 60px;
}
.ChartItem {
  width: 75%;
  font-size: 16px;
  margin-left: 10px;
  padding: 8px;
}
.GraphDiv {
  display: inline-block;
  width: 35%;
  text-align: left;
}
.ItemDivider {
  border-top: 2px solid lightgray !important;
}
.BarGraphDiv {
  width: 100%;
  text-align: right;
}
.BarGraphDivUptime {
  display: inline-block;
  width: 50%;
  height: 50%;
  text-align: right;
}
.iconImg {
  height: 23px;
  width: 23px;
  vertical-align: top;
}
.failed-circle::v-deep {
  path {
    stroke: white !important;
  }
  border-radius: 20px;
  height: 40px;
  width: 40px;
  color: white;
  display: inline-block;
  text-align: center;
}
.visible-circle::v-deep {
  path {
    fill: white !important;
  }
  border-radius: 20px;
  height: 40px;
  width: 40px;
  color: white;
  display: inline-block;
  text-align: center;
}
.circle::v-deep {
  path {
    fill: white !important;
  }
  border-radius: 20px;
  height: 40px;
  width: 40px;
  color: white;
  display: inline-block;
  text-align: center;
  // line-height: 51px;
  // padding-left: 1px;
  // padding-top: 7px;
}
.ReportArea ::v-deep {
  .col-md-6,
  .col-md-12 {
    padding: 4px;
  }
  .row {
    padding: 0;
  }
  .col-md-6 {
    padding-bottom: 10px;
  }
}
.icon-middle::v-deep {
  vertical-align: bottom;
}
.create-service {
  background-color: #f78f2a;
  color: white;
  font-size: 16px;
  height: 40px;
  border-radius: 4px;
  font-family: "Lato";
}
.install {
  display: flex;
  width: 100%;
}
.NoDataHeader {
  font-size: 16px;
  font-weight: bold;
  color: grey;
  padding-bottom: 32px;
  padding-top: 32px;
}
</style>